<template>
	<div class="error-box">
	  <img
	    class="error-img"
	    src=""
	    width="480"
	    height="480"
	    alt=""
	  />
	  <p class="error-text">{{errMsg.message}}</p>
	  <button type="button" class="btn-back" @click="goIndexPage">
	    返回首页
	  </button>
	  <button type="button" class="btn-back" @click="goPrePage">
	    返回上一页
	  </button>
	  <Foot class="Foot"></Foot>
	</div>
</template>

<script>
import Foot from "../components/Foot.vue"
	export default{
		name:'ErrorPage',
		components: {
			Foot
		},
		props:{
			// errMsg:{
			// 	type:Object,
			// 	default: () => {
			// 		return{
			// 			status:404,
			// 			message:'访问的页面不存在！'
			// 		}
			// 	}
			// }
		},
		computed:{
			// 错误信息
			errMsg(){
				return this.$store.state.errInfo;
			}
		},
		beforeDestroy() {
			this.$store.commit('changeErrPageShow', false);
		},
		methods:{			
			// 去首页(不加onComplete、onAbort会报错，vue-router不允许跳转路由到自身)
			goIndexPage() {
			  this.$store.commit("changeErrPageShow", false);
			  this.$router.replace(
			    { path: "/" },
			    (onComplete) => {},
			    (onAbort) => {}
			  );
			},
			// 关闭错误页
			goPrePage() {
			  this.$store.commit("changeErrPageShow", false);
			  this.$router.go(-2);
			},
		}
	}
</script>

<style scoped>
	.Foot{
		width: 100%;
		text-align: center;
		position: absolute;
		bottom:30px;
		left:0;
	}
	.error-box {
	  text-align: center;
	  min-height: 1100px;
	  height: 100%;
	  background-color: #fff;
	  display: flex;
	  flex-direction: column;
	  justify-content: center;
	  align-items: center;
	}
	.error-img {
	  display: inline-block;
	  width: 416px;
	  height: auto;
	  margin-top: -96px;
	}
	.error-text {
	  font-size: 36px;
	  color: #959595;
	  margin-bottom: 48px;
	}
	.error-box .btn-back {
	  display: block;
	  width: 240px;
	  line-height: 92px;
	  border: 1px solid #4188f2;
	  color: #4188f2;
	  border-radius: 12px;
	  margin-top: 30px;
	  font-size: 28px;
	  background-color: transparent;
	}
</style>
